import React from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { Button, Card, CardBody, Col, FormGroup } from 'reactstrap';
import validate, { FormatParams } from './validate';
import { AppState } from '@Redux/store';
import ReduxFormTextarea from '@Utils/ReduxFormTextarea';
import { FormatError, VersionGame } from '@Models';
import Repeater from '@Utils/Repeater';
import classNames from 'classnames';
import ReduxFormDatePicker from '@Utils/ReduxFormDatePicker';
import ReduxFormSelect from '@Utils/ReduxFormSelect';
import { GameView } from '@Selectors/builder/myArmyList/common/ArmyListView';
import { Dispatch } from '@Redux/type';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

interface Props {
  cancel: () => void;
  onSubmit: (values: FormatParams) => void;
  canSubmit: boolean;
  onImport: (values: FormatParams) => void;
  canImport: boolean;
}

export const Form: React.FC<FormProps & InjectedFormProps<FormatParams, FormProps>> = ({
                                                                                 games,
                                                                                 errors,
                                                                                 cancel,
                                                                                 handleSubmit,
                                                                                 onSubmit,
                                                                                 onImport,
                                                                                 canSubmit,
                                                                                 canImport
                                                                               }) => {
  return (
    <form>
      <Col sm="12">
        <Card className="card-border">
          <CardBody>
            <h2 className="text-center"><FormattedMessage {...defaultMessages.formatNewTitle} /></h2>

            <FormGroup row={true}>
              <Col xs="12" lg="6">
                <Field
                  name="date"
                  showTime={false}
                  component={ReduxFormDatePicker}
                  label={defaultMessages.formatFormDateTitle}
                  placeHolder={defaultMessages.formatFormDatePlaceholder}
                />
              </Col>
              <Col xs="12" lg="6">
                <Field
                  name="game"
                  datas={games}
                  component={ReduxFormSelect}
                  label={defaultMessages.formatFormGameTitle}
                  placeHolder={defaultMessages.formatFormGamePlaceholder}
                />
              </Col>
            </FormGroup>

            <FormGroup row={true}>
              <Col xs="12" lg="6">
                <Field
                  name="source"
                  rows={15}
                  component={ReduxFormTextarea}
                  label={defaultMessages.formatFormSourceTitle}
                  placeHolder={defaultMessages.formatFormSourcePlaceholder}
                />
              </Col>
              <Col xs="12" lg="6">
                <Field
                  name="formated"
                  rows={15}
                  component={ReduxFormTextarea}
                  label={defaultMessages.formatFormFormatedTitle}
                  placeHolder={defaultMessages.formatFormFormatedTitle}
                  disabled={true}
                />
              </Col>
            </FormGroup>

            <FormGroup row={true}>
              <Col xs="12" md={{ size: 6, offset: 3 }}>
                <ul>
                  <Repeater data={errors} indexPrefix="error">
                    {(item: FormatError) => (
                      <li className={classNames(item.severity)}>
                        {item.message}
                      </li>
                    )}
                  </Repeater>
                </ul>
              </Col>
            </FormGroup>
          </CardBody>
          <div className="mb-2 text-center">
            <Button disabled={!canSubmit} onClick={() => cancel()} color="age">
              <FormattedMessage {...defaultMessages.formCancel} />
            </Button>
            <Button
              disabled={!canSubmit}
              color="age"  className="ms-1"
              onClick={handleSubmit((values) => onSubmit(values))}
            >
              <FormattedMessage {...defaultMessages.formFormat} />
            </Button>
            <Button
              disabled={!canImport}
              color="age"  className="ms-1"
              onClick={handleSubmit((values) => onImport(values))}
            >
              <FormattedMessage {...defaultMessages.formImport} />
            </Button>
          </div>
        </Card>
      </Col>
    </form>
  );
};

const FormatArmyListForm = reduxForm<FormatParams, FormProps>({
  form: 'format_army_list',
  validate
})(Form);

// Decorate with connect to read form values
// @ts-ignore
const selector = formValueSelector('format_army_list'); // <-- same as form name

const mapStateToProps = (state: AppState, props: Props) => {
  return {
    games: [
      { id: VersionGame.NinthAge, name: 'Ninth Age' } satisfies GameView as GameView,
      { id: VersionGame.WarhammerBattle, name: 'Warhammer Battle' } satisfies GameView as GameView,
      { id: VersionGame.EssenceOfWar, name: 'Essence of War' } satisfies GameView as GameView,
      { id: VersionGame.TheOldWorld, name: 'Old World' } satisfies GameView as GameView,
    ],
    errors: selector(state, 'errors') ?? [],
    onSubmit: props.onSubmit,
    onImport: props.onImport,
    initialValues: {
      date: new Date(),
      game: VersionGame.NinthAge
    }
  };
};

const mapDispatchToProps = (_: Dispatch) => ({})

type FormProps = Props &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

export default connect(mapStateToProps, mapDispatchToProps)(FormatArmyListForm);
